export const buildDepositsFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'event_name',
        label: 'Event Name',
        type: 'search',
        options: (filterOptions.event_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
      {
        id: 'event_status',
        label: 'Event Status',
        type: 'checkbox',
        options: (filterOptions.event_status_options || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
    ],
  },
  {
    id: 'payment',
    label: 'Payment',
    filters: [
      {
        id: 'payment_status',
        label: 'Payment Status',
        type: 'checkbox',
        options: [
          { value: 'Paid', label: 'Paid' },
          { value: 'Unpaid', label: 'Unpaid' },
        ],
      },
    ],
  },
];
